import { CheckoutMetaDataType as o } from "@ancon/wildcat-types";
function i(t) {
  var n;
  if (t)
    return (n = t.find(
      (e) => (e == null ? void 0 : e.metaDataType) === o.PenguinLockers
    )) == null ? void 0 : n.metaData;
}
export {
  i as default
};
